import React, { useRef, useEffect } from 'react'
import { components } from 'cng-web-lib'
import CngSection from '../../../components/cngcomponents/CngSection'
import PersonDocumentDTOEntry from './PersonDocumentDTOEntry'
import { Grid, Tooltip, Divider } from '@material-ui/core'
import { useFormContext } from 'react-hook-form'
import _ from 'lodash'
import PersonDTOFormProperties from './PersonDTOFormProperties'
import PersonDocumentDTOFormProperties from './PersonDocumentDTOFormProperties'
import { FileForUserGetUserDetails } from 'src/common/FileForUserCommon'
import ACIHighwayManifestTranslationText from './../contexts/ACIHighwayManifestTranslationText'

const {
  button: { CngIconButton }
} = components

const { initialValues } = PersonDocumentDTOFormProperties.formikProps

function PersonDocumentSection(props) {
  const { personDocumentDTO, showNotification, title, _personDTOId, personIndex, getFieldName } = props

  const { getValues, setValue } = useFormContext()
  const lastIndex = useRef(personDocumentDTO.length)

  const aciHighwayManifestTranslationText = ACIHighwayManifestTranslationText()

  useEffect(() => {
    let fileForUserDetails = FileForUserGetUserDetails();
    if (fileForUserDetails != null && fileForUserDetails != undefined) {
      personDocumentDTO.forEach(data => {
        data.fileForUserId = fileForUserDetails.fileForUserId;
        data.fileForUserLoginId = fileForUserDetails.fileForUserLoginId;
        data.fileForUserPartyId = fileForUserDetails.fileForUserPartyId;
      });
    }
  }, [personDocumentDTO]);

  useEffect(() => {
    if (personDocumentDTO.length === 0) {
      const { initialValues } = PersonDocumentDTOFormProperties.formikProps
      setValue(getFieldName('personDocumentDTO'), [{ ...initialValues, _personDTOId, _id: 1 }])
    }
  }, [])

  function handleAddPersonDocumentDTO(data) {
    const tempPersonDocumentDTO = [...personDocumentDTO, data].map(
      (document, index) => ({ ...document, _personDTOId, _id: index + 1 })
    )

    setValue(getFieldName('personDocumentDTO'), tempPersonDocumentDTO, { shouldDirty: true })
  }

  function handleDeletePersonDocumentDTO(data) {
    const personDocumentList = personDocumentDTO || [];

    const clonedPersonDocumentList = personDocumentList.filter((document) =>
      document.id ? document.id !== data.id : document._id !== data._id
    );

    const updatedPersonDocumentList = clonedPersonDocumentList.map(
      (document, index) => ({ ...document, _id: index + 1 })
    )

    setValue(getFieldName('personDocumentDTO'), updatedPersonDocumentList, { shouldDirty: true });
  }

  return (
    <CngSection title={title} alignItems='flex-end'>
      <Grid container spacing={2}>
        {personDocumentDTO.map((document, index) => (
          <React.Fragment key={document._id || document.id || index}>
            <Grid item xs={12}>
              <PersonDocumentDTOEntry
                index={index}
                personIndex={personIndex}
                isLast={personDocumentDTO.length === 1}
                onAddPersonDocumentDTO={handleAddPersonDocumentDTO}
                onDeletePersonDocumentDTO={handleDeletePersonDocumentDTO}
                personDocumentDTO={document}
                showNotification={showNotification}
              />
            </Grid>
            {personDocumentDTO.length !== index + 1 && (
              <Grid item xs={12}>
                <Divider />
              </Grid>
            )}
          </React.Fragment>
        ))}
        {personDocumentDTO.length === 0 && (
          <Grid item xs={12}>
            <Grid container spacing={1}>
              <Grid item xs='auto'>
                <Tooltip placement='bottom' title={aciHighwayManifestTranslationText.addNewLabel}>
                  <span>
                    <CngIconButton
                      icon={['fal', 'plus']}
                      onClick={() => handleAddPersonDocumentDTO(initialValues)}
                      size='small'
                      type='outlined'
                    />
                  </span>
                </Tooltip>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Grid>
    </CngSection>
  )
}

export default PersonDocumentSection
